import {
  SET_SERVER_ERROR,
  SET_BUILDER_STATUS,
  SET_SETTINGS_SUBMENU_STATUS,
  CHANGE_ITEMS_PER_PAGE,
    SET_CURRENT_SEQUENCE_PAGE
} from "./types";

export default {
  setServerError({ commit }, status) {
    commit({
      type: SET_SERVER_ERROR,
      payload: status
    });
  },

  setBuilderStatus({ commit }, status) {
    commit({
      type: SET_BUILDER_STATUS,
      payload: status
    });
  },

  setSettingsSubmenuStatus({ commit }, status) {
    commit({
      type: SET_SETTINGS_SUBMENU_STATUS,
      payload: status
    });
  },

  changeItemPerPage({ commit }, val) {
    commit({
      type: CHANGE_ITEMS_PER_PAGE,
      payload: val
    });
  },

  setCurrentSequencePage({ commit }, val) {
    commit({
      type: SET_CURRENT_SEQUENCE_PAGE,
      payload: val
    });
  },


};
